// removed by extract-text-webpack-plugin
module.exports = {"user-container":"user-container","the-news":"the-news","the-news-wrap-container":"the-news-wrap-container","the-news-wrap-item":"the-news-wrap-item","create-product-box":"create-product-box","wrap-create-product":"wrap-create-product","create-product-header":"create-product-header","post-product":"post-product","wrap-next-steps":"wrap-next-steps","wrap-other-actions":"wrap-other-actions"};


//////////////////
// WEBPACK FOOTER
// ./components/users/sub-view/the-news/style.scss
// module id = ./components/users/sub-view/the-news/style.scss
// module chunks = 0